export const INACTIVE_INTERNATIONAL_TRANSACTION_ERROR_CODE = 10500;

export const FEATURES_TOGGLE_KEYS = {
  CUSTOM_REMARK_LENGTH: "dis_remark_length",
  BNI_VA_TU_DTK: "dis_bni_va_tu_dtk",
  EXCHANGE_RATE_UPDATE_FAILURE_PREVENTION: "dis_exchange_rate_update_failure_prevention",
  DASHBOARD_SIGN_API_REQUEST: "dis_dashboard_sign_api_requests",
  REVERSAL_DEPOSIT_INFO: "dis_deposit_history_search",
  SEABANK_REPORT_FORMAT: "dis_seabank_report_format",
  CHARGE_FEE_BY_BENEFICIARY: "charge_fee_by_beneficiary",
  REMOVE_PAGINATION_HISTORY: "dis_remove_pagination",
  BNI_VA_TU_ROUTE: "dis_bni_va_tu_route",
  ENABLE_ROLE_CHECKER: "dis_enable_role_checker"
};
